export default function isAlvies() {
  const href = window.location.href;
  return (href || '').toLowerCase().indexOf('alvies') !== -1;
}
